var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createElement as _createElement } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import moment from 'moment';
import { FormattedMessage, defineMessages, injectIntl } from "react-intl";
import { getAccountHistory as getAccountHistoryAction, clearAccountHistory as clearAccountHistoryAction } from '../../actions/creators/accountHistory';
import { Helmet } from 'react-helmet';
import { fetchOperationType } from '../../constants/operations.js';
import accHistoryComponentFactory from './AccHistoryComponentFactory';
import Date from '../shared/newDate/Date.jsx';
import DateRange from '../shared/newDate/DateRange.jsx';
import Loader from '../../components/Loader';
import { withRouter } from 'react-router';
var messages = defineMessages({
    history_bets_type_active: {
        id: 'history_bets_type_active',
        defaultMessage: 'Today'
    },
    history_bets_type_today: {
        id: 'history_bets_type_today',
        defaultMessage: 'Today'
    },
    history_bets_type_yesterday: {
        id: 'history_bets_type_yesterday',
        defaultMessage: 'Yesterday'
    },
    history_bets_type_on_date: {
        id: 'history_bets_type_on_date',
        defaultMessage: 'On Date'
    },
    history_bets_type_for_period: {
        id: 'history_bets_type_for_period',
        defaultMessage: 'For Period'
    },
    profile_account_history: {
        id: 'profile.account_history',
        defaultMessage: 'Account History'
    },
    internal_error_code_100: {
        id: 'member-area.selfblocking_internal_error_code_100',
        defaultMessage: 'Внутренняя ошибка системы. Попробуйте позже'
    },
    show_btn: {
        id: 'account_history.show',
        defaultMessage: 'Показать'
    },
    betting_history_on_date: {
        id: 'betting_history_on_date',
        defaultMessage: 'Выберите желаемый дату'
    },
    betting_history_on_period: {
        id: 'betting_history_on_period',
        defaultMessage: 'Выберите желаемую период'
    },
    history_account_table_no_data: {
        id: 'member-area.history_account_table_no_data',
        defaultMessage: 'За выбранный период операций не найдено'
    },
    account_history: {
        id: 'menu.user.account_history',
        defaultMessage: 'История счета',
    }
});
var AccountHistory = /** @class */ (function (_super) {
    __extends(AccountHistory, _super);
    function AccountHistory() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            filterItems: [
                { msg: 'history_bets_type_today', value: 'active' },
                { msg: 'history_bets_type_yesterday', value: 'yesterday' },
                { msg: 'history_bets_type_on_date', value: 'date' },
                { msg: 'history_bets_type_for_period', value: 'period' },
            ],
            filterType: 'active',
            showDateRangePicker: false,
            showDatePicker: false,
            dateFrom: moment().startOf('day'),
            dateTo: moment().endOf('day'),
        };
        _this.onDateChange = function (date) {
            _this.setState({
                dateFrom: moment(date).startOf('day'),
                dateTo: moment(date).endOf('day'),
            });
        };
        _this.startDateChange = function (date) {
            _this.setState({
                dateFrom: moment(date).startOf('day')
            });
        };
        _this.endDateChange = function (date) {
            _this.setState({
                dateTo: moment(date).endOf('day')
            });
        };
        _this.onDateSelectHandle = function (e) {
            var period = e.target.value;
            switch (period) { //eslint-disable-line default-case
                case 'today':
                    _this.setState({
                        showDateRangePicker: false,
                        showDatePicker: false,
                        dateFrom: moment().startOf('day'),
                        dateTo: moment().endOf('day')
                    });
                    _this.onSubmit(moment().startOf('day').startOf('day').format('YYYY-MM-DDTHH:mm:ss'), moment().endOf('day').format('YYYY-MM-DDTHH:mm:ss'));
                    break;
                case 'yesterday':
                    _this.setState({
                        showDateRangePicker: false,
                        showDatePicker: false,
                    });
                    _this.onSubmit(moment().subtract(1, 'day').startOf('day').format('YYYY-MM-DDTHH:mm:ss'), moment().subtract(1, 'day').endOf('day').format('YYYY-MM-DDTHH:mm:ss'));
                    break;
                case 'period':
                    _this.setState({
                        dateFrom: moment().subtract(6, 'day').startOf('day'),
                        dateTo: moment().endOf('day')
                    });
                    _this.props.clearAccountHistoryAction();
                    break;
                case 'date':
                    _this.setState({
                        dateFrom: moment().startOf('day'),
                        dateTo: moment().endOf('day')
                    });
                    _this.props.clearAccountHistoryAction();
                    break;
                default:
                    _this.onSubmit(moment().startOf('day').startOf('day').format('YYYY-MM-DDTHH:mm:ss'), moment().endOf('day').format('YYYY-MM-DDTHH:mm:ss'), 'active');
            }
            _this.setState({
                filterType: e.target.value
            });
        };
        _this.onSubmit = function (startDate, finishDate) {
            var data = {
                startDate: startDate,
                finishDate: finishDate,
                languageId: _this.props.languageId
            };
            _this.props.getAccountHistoryAction(data);
        };
        return _this;
    }
    AccountHistory.prototype.componentDidMount = function () {
        this.onSubmit(moment().startOf('day').startOf('day').format('YYYY-MM-DDTHH:mm:ss'), moment().endOf('day').format('YYYY-MM-DDTHH:mm:ss'));
    };
    AccountHistory.prototype.componentWillUnmount = function () {
        this.props.clearAccountHistoryAction();
    };
    AccountHistory.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.languageId !== this.props.languageId) {
            var data = {
                startDate: this.state.dateFrom.format('YYYY-MM-DDTHH:mm:ss'),
                finishDate: this.state.dateTo.format('YYYY-MM-DDTHH:mm:ss'),
                languageId: this.props.languageId
            };
            this.props.getAccountHistoryAction(data);
        }
    };
    AccountHistory.prototype._renderItem = function (item) {
        var type = fetchOperationType(item.OperationType);
        return accHistoryComponentFactory(type, item);
    };
    AccountHistory.prototype._renderData = function () {
        var _this = this;
        var operationsData = this.props.operationsData;
        if (operationsData.length === 0) {
            return (_jsx("div", __assign({ className: 'items no-bets', style: { marginTop: '-15px' } }, { children: _jsx(FormattedMessage, __assign({}, messages.history_account_table_no_data)) })));
        }
        else {
            return (_jsx("div", __assign({ className: 'items items--account-history' }, { children: operationsData.map(function (item) { return _this._renderItem(item); }) })));
        }
    };
    AccountHistory.prototype.render = function () {
        var _this = this;
        var _a = this.props, operationsData = _a.operationsData, languageId = _a.languageId, error = _a.error, operationsLoading = _a.operationsLoading, intl = _a.intl;
        var _b = this.state, filterItems = _b.filterItems, filterType = _b.filterType, dateFrom = _b.dateFrom, dateTo = _b.dateTo;
        var pageTitle = intl.formatMessage(messages.account_history);
        var startDate = moment(dateFrom).format('YYYY-MM-DDTHH:mm:ss');
        var finishDate = moment(dateTo).format('YYYY-MM-DDTHH:mm:ss');
        var showDatePicker = filterType === 'period' || filterType === 'date';
        var dateRangeProps = {
            languageId: languageId,
            dateFrom: moment().subtract(6, 'day').startOf('day').format('DD.MM.YYYY'),
            dateTo: moment().format('DD.MM.YYYY'),
            endDateChange: this.endDateChange,
            startDateChange: this.startDateChange
        };
        return (_jsxs("div", __assign({ id: 'content' }, { children: [_jsx(Helmet, { children: _jsxs("title", { children: [window.COMPANY_NAME, " \u2014 ", pageTitle] }) }), _jsxs("div", __assign({ className: 'backward' }, { children: [_jsx("a", { className: 'ajax', onClick: function () { return _this.props.history.goBack(); } }), _jsx("div", __assign({ className: 'header' }, { children: _jsx("div", __assign({ className: 'title' }, { children: _jsx(FormattedMessage, __assign({}, messages.profile_account_history)) })) }))] })), _jsxs("div", __assign({ className: 'block blc_history blc_info' }, { children: [operationsLoading && _jsx(Loader, {}), _jsx("div", __assign({ className: 'filter' }, { children: _jsx("div", __assign({ className: 'rows' }, { children: _jsxs("div", __assign({ className: 'history__filter' }, { children: [_jsx("div", __assign({ className: 'history__filter__items' }, { children: filterItems.map(function (item) {
                                                var cls = item.value === filterType ? 'history__filter__item history__filter__item--active' : 'history__filter__item';
                                                return (_createElement(FormattedMessage, __assign({}, messages[item.msg], { key: item.value }), function (message) { return _jsx("button", __assign({ value: item.value, className: cls, onClick: _this.onDateSelectHandle }, { children: message })); }));
                                            }) })), showDatePicker &&
                                            _jsxs("div", __assign({ className: 'history__filter__datepick' }, { children: [filterType === 'date' && _jsx(Date, { onDateChange: this.onDateChange, languageId: languageId, dateFrom: dateFrom }), filterType === 'period' && _jsx(DateRange, __assign({}, dateRangeProps)), _jsx("button", __assign({ onClick: function () { return _this.onSubmit(startDate, finishDate); }, disabled: operationsLoading, className: 'history__filter__datepick__btn' }, { children: _jsx(FormattedMessage, __assign({}, messages.show_btn)) }))] }))] })) })) })), (filterType === 'date') && operationsData === undefined &&
                            _jsx("div", __assign({ className: 'items no-bets', style: { marginTop: '-15px' } }, { children: _jsx(FormattedMessage, __assign({}, messages.betting_history_on_date)) })), (filterType === 'period') && operationsData === undefined &&
                            _jsx("div", __assign({ className: 'items no-bets', style: { marginTop: '-15px' } }, { children: _jsx(FormattedMessage, __assign({}, messages.betting_history_on_period)) })), !operationsLoading && !error && operationsData !== undefined && this._renderData(), !operationsLoading && error && _jsx(FormattedMessage, __assign({}, messages.internal_error_code_100))] }))] })));
    };
    return AccountHistory;
}(React.Component));
AccountHistory.propTypes = {
    operationsData: PropTypes.any,
    getAccountHistoryAction: PropTypes.func.isRequired,
    clearAccountHistoryAction: PropTypes.func.isRequired,
    operationsLoading: PropTypes.bool.isRequired,
    languageId: PropTypes.number.isRequired,
    error: PropTypes.bool.isRequired
};
function mapToState(state) {
    var languageId = state.application.get('languageId');
    var operationsData = state.application.get('operations').get('data');
    var operationsLoading = state.application.get('operations').get('isLoading');
    var error = state.application.getIn(['operations', 'error']);
    return {
        languageId: languageId,
        operationsData: operationsData,
        operationsLoading: operationsLoading,
        error: error
    };
}
var mapDispatchToProps = function (dispatch) { return bindActionCreators({
    getAccountHistoryAction: getAccountHistoryAction,
    clearAccountHistoryAction: clearAccountHistoryAction
}, dispatch); };
export default withRouter(connect(mapToState, mapDispatchToProps)(injectIntl(AccountHistory)));



// WEBPACK FOOTER //
// ./src/components/account-history/Index.jsx